'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePage = exports.getPageShortName = exports.createPage = exports.createPageTags = exports.createPageTag = exports.fetchPageDonationCount = exports.fetchPageTags = exports.fetchPagesByTag = exports.fetchUserPages = exports.fetchPage = exports.fetchPages = exports.deserializePage = exports.pageNameRegex = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

var _chunk = require('lodash/chunk');

var _chunk2 = _interopRequireDefault(_chunk);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _flattenDeep = require('lodash/flattenDeep');

var _flattenDeep2 = _interopRequireDefault(_flattenDeep);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _slugify = require('slugify');

var _slugify2 = _interopRequireDefault(_slugify);

var _uuid = require('uuid');

var _client = require('../../utils/client');

var _justgiving = require('../../utils/justgiving');

var _params = require('../../utils/params');

var _tags = require('../../utils/tags');

var _fitnessActivities = require('../fitness-activities');

var _totals = require('../../utils/totals');

var _jsonDate = require('../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pageNameRegex = exports.pageNameRegex = /[^\w\s',-]/gi;

var deserializePage = exports.deserializePage = function deserializePage(page) {
  var shortName = page.shortName || page.pageShortName || (page.LinkPath || '').substring(1) || page.PageUrl;

  var getImage = function getImage() {
    return page.defaultImage || page.Logo || page.Photo || (0, _justgiving.imageUrl)(page.photo) || (0, _justgiving.imageUrl)((0, _get2.default)(page, 'pageImages[0]')) || (0, _get2.default)(page, 'image.url') || (0, _get2.default)(page, 'images[0].url') || (0, _justgiving.apiImageUrl)(shortName);
  };

  var getQrCodes = function getQrCodes(page) {
    var images = (0, _get2.default)(page, 'media.images', []);
    return (0, _filter2.default)(images, function (image) {
      return image.caption === 'qrcode';
    });
  };

  var isOnlinePresent = typeof page.totalRaisedOnline !== 'undefined';
  var onlineAmount = isOnlinePresent ? parseFloat(page.totalRaisedOnline) : parseFloat(page.Amount || page.raisedAmount || page.amountRaised || 0);

  var offlineAmount = parseFloat(page.totalRaisedOffline || 0);
  var status = page.status || page.pageStatus;
  var id = page.pageId || page.Id;

  return {
    active: status ? ['Inactive', 'Cancelled', 'Offline'].indexOf(status) === -1 : true,
    campaign: page.campaignGuid || page.Subtext || page.eventId || page.EventId,
    campaignDate: (0, _jsonDate2.default)(page.eventDate) || page.EventDate,
    charity: page.charity || page.CharityId || page.charityId,
    charityId: (0, _get2.default)(page, 'charity.id') || page.CharityId,
    coordinates: null,
    createdAt: (0, _jsonDate2.default)(page.createdDate) || page.CreatedDate,
    currencyCode: page.currencyCode,
    currencySymbol: page.currencySymbol,
    donationUrl: id ? (0, _justgiving.baseUrl)('link') + '/v1/fundraisingpage/donate/pageId/' + id : (0, _justgiving.baseUrl)('www') + '/fundraising/' + shortName + '/donate',
    event: page.Subtext || page.eventId || page.EventId || page.eventName,
    expired: (0, _jsonDate2.default)(page.expiryDate) && (0, _dayjs2.default)(page.expiryDate).isBefore(),
    fitness: page.fitness || {},
    fitnessActivities: (0, _get2.default)(page, 'fitness.activities', []).map(_fitnessActivities.deserializeFitnessActivity),
    fitnessGoal: parseInt(page.pageSummaryWhat) || 0,
    fitnessDistanceTotal: (0, _get2.default)(page, 'fitness.totalAmount', 0) || (0, _get2.default)(page, 'fitness.distance', 0),
    fitnessDurationTotal: (0, _get2.default)(page, 'fitness.totalAmountTaken', 0) || (0, _get2.default)(page, 'fitness.duration', 0),
    fitnessElevationTotal: (0, _get2.default)(page, 'fitness.totalAmountElevation', 0) || (0, _get2.default)(page, 'fitness.elevation', 0),
    fitnessSettings: (0, _get2.default)(page, 'fitness.pageFitnessSettings'),
    groups: null,
    hasUpdatedImage: page.imageCount && parseInt(page.imageCount - getQrCodes(page).length) > 1,
    id: id,
    image: getImage() && getImage().split('?')[0] + '?template=CrowdfundingOwnerAvatar',
    name: page.title || page.pageTitle || page.Name || page.name || page.PageName || (0, _get2.default)(page, 'pageOwner.fullName'),
    owner: page.owner ? !(0, _get2.default)(page, 'owner.firstName') ? page.owner : (0, _get2.default)(page, 'owner.firstName') + ' ' + (0, _get2.default)(page, 'owner.lastName') : page.OwnerFullName || page.PageOwner || page.pageOwner || (0, _get2.default)(page, 'pageOwner.fullName'),
    qrCodes: getQrCodes(page),
    raised: onlineAmount + offlineAmount,
    raisedOnline: onlineAmount,
    raisedOffline: offlineAmount,
    segmentation: deserializeSegmentation(page.tags),
    slug: shortName,
    story: page.story || page.ProfileWhat || page.ProfileWhy,
    tags: page.tags || [],
    target: parseFloat(page.fundraisingTarget || page.TargetAmount || page.targetAmount || page.target || 0),
    teamPageId: page.teams && page.teams.length > 0 ? page.teams[0].teamGuid : null,
    teamShortName: page.teams && page.teams.length > 0 ? page.teams[0].teamShortName : null,
    type: page.type || 'individual',
    url: page.Link || page.PageUrl || (0, _justgiving.baseUrl)() + '/fundraising/' + shortName,
    uuid: page.pageGuid || page.fundraisingPageGuid
  };
};

var deserializeSegmentation = function deserializeSegmentation() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return tags.reduce(function (segments, tag) {
    var key = (0, _get2.default)(tag, 'tagDefinition.id');
    var value = (0, _get2.default)(tag, 'value');

    return _extends({}, segments, _defineProperty({}, key, value));
  }, {});
};

var recursivelyFetchJGPages = function recursivelyFetchJGPages(_ref) {
  var campaign = _ref.campaign,
      q = _ref.q,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 10 : _ref$limit,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page;

  var options = {
    params: { page: page, q: q }
  };
  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + campaign + '/pages', options).then(function (response) {
    return response.data;
  }).then(function (data) {
    var _data$meta = data.meta,
        currentPage = _data$meta.currentPage,
        totalPages = _data$meta.totalPages;

    var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(data.results));

    if (Number(currentPage) === totalPages || updatedResults.length >= limit || totalPages === 0) {
      return updatedResults;
    } else {
      page++;
      return recursivelyFetchJGPages({
        campaign: campaign,
        q: q,
        limit: limit,
        results: updatedResults,
        page: page
      });
    }
  });
};

var fetchPages = function fetchPages() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var allPages = params.allPages,
      _params$authType = params.authType,
      authType = _params$authType === undefined ? 'Basic' : _params$authType,
      campaign = params.campaign,
      charity = params.charity,
      event = params.event,
      ids = params.ids,
      token = params.token,
      userPages = params.userPages,
      args = _objectWithoutProperties(params, ['allPages', 'authType', 'campaign', 'charity', 'event', 'ids', 'token', 'userPages']);

  if (userPages && token) {
    return (0, _client.get)('/v1/fundraising/pages', {}, {}, {
      headers: {
        Authorization: [authType, token].join(' ')
      }
    });
  }

  if (allPages && ids) {
    var pageIds = Array.isArray(ids) ? ids : ids.split(',');

    if (pageIds.filter(_params.isUuid).length === pageIds.length) {
      return Promise.all((0, _chunk2.default)(pageIds, 20).map(function (guids) {
        return _client.servicesAPI.get('/v1/justgiving/proxy/fundraising/v2/pages/bulk', {
          params: { pageGuids: guids.join(',') }
        }).then(function (response) {
          return response.data.results;
        });
      })).then(function (results) {
        return (0, _flattenDeep2.default)(results);
      }).then(function (results) {
        return results.filter(function (page) {
          return page.status === 'Active';
        });
      });
    }

    return Promise.all(pageIds.map(fetchPage));
  }

  if (allPages && event) {
    var mappings = { limit: 'pageSize' };

    return (0, _client.get)('/v1/event/' + (0, _params.getUID)(event) + '/pages', args, { mappings: mappings }).then(function (response) {
      return response.fundraisingPages;
    }).then(function (pages) {
      return pages.map(function (page) {
        return _extends({}, page, {
          totalRaisedOffline: page.raisedAmount - page.totalRaisedOnline
        });
      });
    });
  }

  if (!(0, _params.isEmpty)(campaign) && !event) {
    return recursivelyFetchJGPages(_extends({ campaign: (0, _params.getUID)(campaign) }, args));
  }

  return (0, _client.get)('/v1/onesearch', _extends({
    campaignId: (0, _params.getUID)(campaign),
    charityId: (0, _params.getUID)(charity),
    eventId: (0, _params.getUID)(event),
    i: 'Fundraiser'
  }, args)).then(function (response) {
    return response.GroupedResults && response.GroupedResults.length && response.GroupedResults[0].Results || [];
  });
};

exports.fetchPages = fetchPages;
var fetchPage = exports.fetchPage = function fetchPage() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var slug = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var endpoint = slug ? 'pages' : isNaN(page) ? 'pages' : 'pagebyid';

  var fetchers = [new Promise(function (resolve) {
    return (0, _client.get)('/v1/fundraising/' + endpoint + '/' + page).then(function (page) {
      return options.includeFitness ? fetchPageFitness(page, options.fitnessParams).then(function (fitness) {
        return resolve(_extends({}, page, { fitness: fitness }));
      }) : resolve(page);
    });
  }), options.includeTags && fetchPageTags(page)];

  return Promise.all(fetchers).then(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        page = _ref3[0],
        tags = _ref3[1];

    return _extends({}, page, tags);
  });
};

var fetchUserPages = exports.fetchUserPages = function fetchUserPages(_ref4) {
  var _ref4$authType = _ref4.authType,
      authType = _ref4$authType === undefined ? 'Basic' : _ref4$authType,
      campaign = _ref4.campaign,
      charity = _ref4.charity,
      event = _ref4.event,
      _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token;

  var headers = {
    Authorization: [authType, token].join(' ')
  };

  var filterByCampaign = function filterByCampaign(pages, campaign) {
    return campaign ? pages.filter(function (page) {
      return (0, _params.isEqual)(page.campaignGuid, campaign);
    }) : pages;
  };

  var filterByCharity = function filterByCharity(pages, charity) {
    return charity ? pages.filter(function (page) {
      return (0, _params.isEqual)(page.charityId, charity);
    }) : pages;
  };

  var filterByEvent = function filterByEvent(pages, event) {
    return event ? pages.filter(function (page) {
      return (0, _params.isEqual)(page.eventId, event);
    }) : pages;
  };

  return (0, _client.get)('/v1/fundraising/pages', {}, {}, { headers: headers }).then(function (pages) {
    return filterByCampaign(pages, campaign);
  }).then(function (pages) {
    return filterByCharity(pages, charity);
  }).then(function (pages) {
    return filterByEvent(pages, event);
  });
};

var fetchPagesByTag = exports.fetchPagesByTag = function fetchPagesByTag(_ref5) {
  var _ref5$tagId = _ref5.tagId,
      tagId = _ref5$tagId === undefined ? (0, _params.required)() : _ref5$tagId,
      _ref5$tagValue = _ref5.tagValue,
      tagValue = _ref5$tagValue === undefined ? (0, _params.required)() : _ref5$tagValue,
      _ref5$limit = _ref5.limit,
      limit = _ref5$limit === undefined ? 100 : _ref5$limit,
      _ref5$offset = _ref5.offset,
      offset = _ref5$offset === undefined ? 0 : _ref5$offset;
  return (0, _client.get)('v1/tags/search?tagsQuery=tags.' + tagId + '=' + tagValue + '&maxValue=' + limit + '&offset=' + offset);
};

var fetchPageTags = exports.fetchPageTags = function fetchPageTags(page) {
  return (0, _client.get)('v1/tags/' + page);
};

var fetchPageFitness = function fetchPageFitness(page) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$limit = _ref6.limit,
      limit = _ref6$limit === undefined ? 100 : _ref6$limit,
      _ref6$offset = _ref6.offset,
      offset = _ref6$offset === undefined ? 0 : _ref6$offset,
      startDate = _ref6.startDate,
      endDate = _ref6.endDate,
      _ref6$useLegacy = _ref6.useLegacy,
      useLegacy = _ref6$useLegacy === undefined ? true : _ref6$useLegacy;

  var slug = (typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' ? page.pageShortName : page;

  if (useLegacy) {
    var params = { limit: limit, offset: offset, start: startDate, end: endDate };
    return (0, _client.get)('/v1/fitness/fundraising/' + slug, params);
  }

  return (0, _totals.fetchTotals)({
    segment: 'page:totals',
    tagId: 'page:totals',
    tagValue: 'page:fundraising:' + page.pageGuid
  }).then(_totals.deserializeTotals);
};

var fetchPageDonationCount = exports.fetchPageDonationCount = function fetchPageDonationCount() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.get)('/v1/fundraising/pages/' + page + '/donations').then(function (data) {
    return data.pagination.totalResults;
  });
};

var truncate = function truncate(string) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  if (string) {
    return String(string).length > length ? String(string).substring(0, length - 3).trim() + '...' : String(string);
  }

  return undefined;
};

var createPageTag = exports.createPageTag = function createPageTag(_ref7) {
  var _ref7$id = _ref7.id,
      id = _ref7$id === undefined ? (0, _params.required)() : _ref7$id,
      _ref7$label = _ref7.label,
      label = _ref7$label === undefined ? (0, _params.required)() : _ref7$label,
      _ref7$slug = _ref7.slug,
      slug = _ref7$slug === undefined ? (0, _params.required)() : _ref7$slug,
      _ref7$value = _ref7.value,
      value = _ref7$value === undefined ? (0, _params.required)() : _ref7$value,
      _ref7$aggregation = _ref7.aggregation,
      aggregation = _ref7$aggregation === undefined ? [] : _ref7$aggregation;

  var request = function request() {
    return (0, _client.post)('/v1/tags/' + slug, {
      aggregation: aggregation,
      id: id,
      label: label,
      value: value
    }, {
      timeout: 5000
    });
  };

  return request().catch(function () {
    return request();
  }); // Retry if request fails
};

var createPageTags = exports.createPageTags = function createPageTags(_ref8) {
  var _ref8$slug = _ref8.slug,
      slug = _ref8$slug === undefined ? (0, _params.required)() : _ref8$slug,
      _ref8$tagValues = _ref8.tagValues,
      tagValues = _ref8$tagValues === undefined ? (0, _params.required)() : _ref8$tagValues;

  var request = function request() {
    return (0, _client.post)('/v1/tags/' + slug + '/multiple', {
      tagValues: tagValues
    }, {
      timeout: 5000
    });
  };

  return request().catch(function () {
    return request();
  }); // Retry if request fails
};

var createDefaultPageTags = function createDefaultPageTags(page, timeBox) {
  return createPageTags({ slug: page.slug, tagValues: (0, _tags.defaultPageTags)(page, timeBox) });
};

var createPage = exports.createPage = function createPage(_ref9) {
  var _ref9$charityId = _ref9.charityId,
      charityId = _ref9$charityId === undefined ? (0, _params.required)() : _ref9$charityId,
      _ref9$title = _ref9.title,
      title = _ref9$title === undefined ? (0, _params.required)() : _ref9$title,
      _ref9$token = _ref9.token,
      token = _ref9$token === undefined ? (0, _params.required)() : _ref9$token,
      slug = _ref9.slug,
      _ref9$activityType = _ref9.activityType,
      activityType = _ref9$activityType === undefined ? 'othercelebration' : _ref9$activityType,
      attribution = _ref9.attribution,
      _ref9$authType = _ref9.authType,
      authType = _ref9$authType === undefined ? 'Basic' : _ref9$authType,
      campaignId = _ref9.campaignId,
      campaignGuid = _ref9.campaignGuid,
      causeId = _ref9.causeId,
      charityFunded = _ref9.charityFunded,
      _ref9$charityOptIn = _ref9.charityOptIn,
      charityOptIn = _ref9$charityOptIn === undefined ? false : _ref9$charityOptIn,
      companyAppealId = _ref9.companyAppealId,
      consistentErrorResponses = _ref9.consistentErrorResponses,
      currency = _ref9.currency,
      customCodes = _ref9.customCodes,
      eventDate = _ref9.eventDate,
      eventId = _ref9.eventId,
      eventName = _ref9.eventName,
      expiryDate = _ref9.expiryDate,
      giftAid = _ref9.giftAid,
      image = _ref9.image,
      _ref9$images = _ref9.images,
      images = _ref9$images === undefined ? [] : _ref9$images,
      reference = _ref9.reference,
      rememberedPersonReference = _ref9.rememberedPersonReference,
      story = _ref9.story,
      summaryWhat = _ref9.summaryWhat,
      summaryWhy = _ref9.summaryWhy,
      tags = _ref9.tags,
      tagsCallback = _ref9.tagsCallback,
      target = _ref9.target,
      teamId = _ref9.teamId,
      theme = _ref9.theme,
      timeBox = _ref9.timeBox,
      videos = _ref9.videos;

  var pageTitle = title.replace(/’/g, "'");

  return getPageShortName(pageTitle, slug).then(function (pageShortName) {
    return (0, _client.put)('/v1/fundraising/pages', _extends({}, eventId ? {
      eventId: eventId
    } : {
      activityType: activityType,
      eventDate: eventDate,
      eventName: eventName || pageTitle
    }, {
      attribution: attribution,
      campaignGuid: campaignGuid || campaignId,
      causeId: causeId,
      charityFunded: charityFunded,
      charityId: charityId,
      charityOptIn: charityOptIn,
      companyAppealId: companyAppealId,
      consistentErrorResponses: consistentErrorResponses,
      currency: currency,
      customCodes: customCodes,
      expiryDate: expiryDate,
      images: images.length ? images : image ? [{ url: image, isDefault: true }] : undefined,
      isGiftAidable: giftAid,
      pageShortName: pageShortName,
      pageStory: story,
      pageSummaryWhat: summaryWhat,
      pageSummaryWhy: truncate(summaryWhy),
      pageTitle: pageTitle,
      reference: reference,
      rememberedPersonReference: rememberedPersonReference,
      tags: tags,
      targetAmount: target,
      teamId: teamId,
      theme: theme,
      videos: videos
    }), {
      headers: {
        Authorization: [authType, token].join(' ')
      }
    }).then(function (result) {
      return fetchPage(result.pageId);
    }).then(function (page) {
      createDefaultPageTags(deserializePage(page), timeBox).then(function (tags) {
        if (typeof tagsCallback === 'function') {
          tagsCallback(tags, page);
        }
      });

      return page;
    });
  });
};

var getPageShortName = exports.getPageShortName = function getPageShortName(title, slug) {
  var preferredName = slug || (0, _slugify2.default)(title, { lower: true, strict: true });

  var params = {
    preferredName: preferredName.substring(0, 45)
  };

  return (0, _client.get)('/v1/fundraising/pages/suggest', params).then(function (result) {
    return (0, _first2.default)(result.Names) || (0, _uuid.v4)();
  });
};

var updatePage = exports.updatePage = function updatePage() {
  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _ref10 = arguments[1];
  var _ref10$token = _ref10.token,
      token = _ref10$token === undefined ? (0, _params.required)() : _ref10$token,
      attribution = _ref10.attribution,
      _ref10$authType = _ref10.authType,
      authType = _ref10$authType === undefined ? 'Basic' : _ref10$authType,
      image = _ref10.image,
      name = _ref10.name,
      offline = _ref10.offline,
      story = _ref10.story,
      summaryWhat = _ref10.summaryWhat,
      summaryWhy = _ref10.summaryWhy,
      target = _ref10.target;

  var config = { headers: { Authorization: [authType, token].join(' ') } };

  return Promise.all([attribution && (0, _client.put)('/v1/fundraising/pages/' + slug + '/attribution', { attribution: attribution }, config), image && (0, _client.put)('/v1/fundraising/pages/' + slug + '/images', { url: image, isDefault: true }, config), name && (0, _client.put)('/v1/fundraising/pages/' + slug + '/pagetitle', { pageTitle: name.replace(/’/g, "'").replace(pageNameRegex, '') }, config), offline && (0, _client.put)('/v1/fundraising/pages/' + slug + '/offline', { amount: offline }, config), story && (0, _client.put)('/v1/fundraising/pages/' + slug + '/pagestory', { story: story }, config), target && (0, _client.put)('/v1/fundraising/pages/' + slug + '/target', { amount: target }, config), (summaryWhat || summaryWhy) && (0, _client.put)('/v1/fundraising/pages/' + slug + '/summary', {
    pageSummaryWhat: summaryWhat,
    pageSummaryWhy: summaryWhy
  }, config)].filter(function (promise) {
    return promise;
  }));
};